import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';

import { ConfirmDelete } from '../../shared/ui/confirm-delete';
import { ErrorState } from '../../shared/ui/states';
import { deleteDestination, type TDestination } from '../../entities/destination';

interface IDestinationDeleteProps {
  destination: TDestination;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const DestinationDelete = ({ destination, open, onOpenChange }: IDestinationDeleteProps) => {
  const client = useQueryClient();
  const navigate = useNavigate();
  const remove = useMutation({
    mutationFn: () => deleteDestination(destination.id),
    onSuccess: () => {
      onOpenChange(false);
      void client.invalidateQueries({ queryKey: ['destinations'] });
      void navigate({ to: '/destinations' });
    },
  });

  return (
    <ConfirmDelete
      open={open}
      onOpenChange={(next) => {
        onOpenChange(next);
        if (!next) remove.reset();
      }}
      entity="destination"
      name={destination.name}
      waiting={remove.isPending}
      onConfirm={() => remove.mutate()}
      note={remove.isError ? <ErrorState error={remove.error} /> : undefined}
    />
  );
};
